import cn from 'classnames'

import styles from './styles.module.scss'
interface CustomButtonProps {
    onClick?: () => void
    textBtn: string
    classNames?: {
        textBtn?: string
    }
}
export const CustomButton = ({
    onClick,
    textBtn,
    classNames,
}: CustomButtonProps) => {
    return (
        <button className={styles.button_outer} onClick={onClick}>
            <div className={styles.button_inner}>
                <span className={cn(styles.button_text, classNames?.textBtn)}>
                    {textBtn}
                </span>
            </div>
        </button>
    )
}
